// extracted by mini-css-extract-plugin
export default {"wrapper":"ShowMoreTooltip_wrapper__gHck3","inlineDashed":"ShowMoreTooltip_inlineDashed__5BrFs","hasTooltip":"ShowMoreTooltip_hasTooltip__Bjq2U"};